import {Box, Tabs, Tab} from "@mui/material";
import * as React from 'react';
import TabPanel from "../../../../share/components/tab/TabPanel";
import { TimberClass } from "../../../types/models/TimberClass";
import {useStateSession} from "../../../../hooks/useAuth";
import { t } from "@lingui/core/macro";

type IFormProps = {
    data: TimberClass;
};

const TimberClassTabs: React.FC<IFormProps> = ({ data = {} }) => {

    const session = useStateSession()
    const searchParams = new URLSearchParams(window.location.search)

    const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
        
        if (searchParams.has('tab')) {
            searchParams.set('tab', newValue)
        } else {
            searchParams.append('tab', newValue)
        }
        window.history.pushState({}, '', '?' + searchParams.toString())

        
    };

    return (
        <Box sx={ { width: '100%' } }>
            
        </Box>
    )
}

export default TimberClassTabs;
